const colors: string[] = [
  '#70AAFF',
  '#F7D250',
  '#61E57E',
  '#FF7970',
  '#46E7FF',
  '#9670FF',
  '#FF70FF'
]

const recipientColors: string[] = ['#F7D250', '#61E57E', '#FF7970', '#46E7FF', '#9670FF', '#FF70FF']

export { recipientColors }

export default colors
